export default __webpack_public_path__ + "static/media/ShehacksRedefined.ca1a1d73.png";